import React, { useState } from 'react';
import FeatureDescription from '../core/FeatureDescription';
import SectionH2 from '../heading/SectionH2';
import Building from '../../img/building.svg';
import Phone from '../../img/phone.svg';
import LowkeyIcon from '../../img/lowkey_icon.svg';
import BuzzerChecker from './BuzzerChecker';

const SetupProcess = ({ theme = 'dark' }) => {
  const textColor = theme !== 'light' ? 'text-white' : 'text-black';
  const [showChecker, setShowChecker] = useState(false);

  return (
    <div class="px-10">
      <div class="flex flex-col items-center pb-5 pt-1 sm:pb-8">
        <SectionH2 title={'Setup Process'} theme={theme} />
        <div class={`${textColor} max-w-4xl space-y-3 text-center font-space-grotesk-regular`}>
          <p>
            Lowkey gives each building its own virtual phone number that interfaces securely with that building's
            existing buzzer system, no new hardware, no installation.
          </p>
          <p>Set up your whole portfolio in three easy steps.</p>
        </div>
      </div>

      <div class="sm:flex sm:flex-row sm:justify-center sm:pt-5">
        <div class="flex max-w-7xl flex-col justify-center space-y-16 px-8 pt-16 sm:flex-row sm:space-x-8 sm:space-y-0 sm:px-0 sm:py-0">
          <FeatureDescription
            customFontSize={'text-2xl lg:text-3xl'}
            title={'1. Add your buildings'}
            description={`Add each building in the Lowkey app to receive a dedicated virtual number for it.`}
            imageSrc={Phone}
            imageAlt={'phone icon'}
            theme={theme}
          />
          <FeatureDescription
            customFontSize={'text-2xl lg:text-3xl'}
            title={'2. Connect each buzzer'}
            description={`Send each building's number to its property manager so the buzzer dials Lowkey instead of a personal phone.`}
            imageSrc={Building}
            imageAlt={'building icon'}
            theme={theme}
          />
          <FeatureDescription
            customFontSize={'text-2xl lg:text-3xl'}
            title={'3. Manage it all in one place'}
            description={'Switch between buildings, invite your team, and control access across your whole portfolio.'}
            imageSrc={LowkeyIcon}
            imageAlt={'lock icon'}
            theme={theme}
          />
        </div>
      </div>

      <div class="flex flex-col items-center pt-16">
        {showChecker ? (
          <div class="mx-auto w-full max-w-2xl">
            <div class="rounded-2xl bg-gray-900">
              <BuzzerChecker />
            </div>
            <div class="pt-6 text-center">
              <button
                type="button"
                onClick={() => setShowChecker(false)}
                class="text-sm text-gray-lowkey-medium underline"
              >
                Hide
              </button>
            </div>
          </div>
        ) : (
          <button
            type="button"
            onClick={() => setShowChecker(true)}
            class="inline-flex items-center justify-center rounded-lg border border-green-lowkey bg-green-lowkey py-3 px-5 text-center text-base font-medium text-black hover:bg-black hover:text-green-lowkey focus:ring-4 focus:ring-gray-800"
          >
            Check if your buildings' buzzers work with Lowkey
          </button>
        )}
      </div>
    </div>
  );
};

export default SetupProcess;
